import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi';
 import './style.css'; 
 let SolutionScoreCard=(props)=> { 
   
  
  return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  Solution ScoreCard
  </h4> 
        <br></br>
        <h6 id="h62">Solution scorecard evaluates effectiveness of your solution to solve the problem</h6>
        <h6 id="h6">
  Solution scorecard also enables you to understand many critical aspect of the solution as your are evaluating it</h6>
        <div id='divL'>
          <table id='tableAll'>
            <thead>
              <tr>
                <th scope="col">Category</th>
                <th scope="col">Score</th>
                <th scope="col">Catagory</th>
                <th scope="col">Score</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Category">opportunity Window (TimeAvailable to lauch solution)</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Months</option>
                    <option value="2">Years</option>
                  </select>
                </td>
                <td data-label="Catagory">Effort For Result (How much Effor a Coustomer has to put solution in it)</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Wow</option>
                    <option value="2">Acceptable</option>
                    <option value="3">sucks</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Category">Expected Solution Life</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Months</option>
                    <option value="2">Years</option>
                  </select>
                </td>
                <td data-label="Catagory">Acess To Solution (Coustomer on Boarding Effort)</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Easy</option>
                    <option value="2">OK</option>
                    <option value="3">Hard</option>
                  </select>
                </td>
              </tr>
              <tr>
              <td data-label="Category">Cost of Service</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Low</option>
                    <option value="2">Medium</option>
                    <option value="3">High</option>

                  </select>
                </td>
                <td data-label="Catagory">Domain Expertiese</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Low</option>
                    <option value="2">Medium</option>
                    <option value="3">High</option>
                  </select>
                </td>
              </tr>


              <tr>
              <td data-label="Category">Time to Design Result</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Wow</option>
                    <option value="2">Good</option>
                    <option value="3">Suck</option>
                    <option value="4">Unknow</option>

                  </select>
                </td>
                <td data-label="Catagory">Reliablity : How ofter your solution works</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Low</option>
                    <option value="2">Medium</option>
                    <option value="3">High</option>
                  </select>
                </td>
              </tr>

              <tr>
              <td data-label="Category">Reputatuion of solution provider</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Low</option>
                    <option value="2">Medium</option>
                    <option value="3">High</option>

                  </select>
                </td>
                <td data-label="Catagory">Technology solution feasibility</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Low</option>
                    <option value="2">Medium</option>
                    <option value="3">High</option>
                  </select>
                </td>
              </tr>



              <tr>
              <td data-label="Category">Time to market</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">No</option>
                    <option value="2">Go</option>
                    <option value="3">Yes</option>

                  </select>
                </td>
                <td data-label="Catagory">Budget for building solution</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">See Funding Source</option>
 
                  </select>
                </td>
              </tr>


              <tr>
              <td data-label="Category">Time to Revenew</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1Y</option>
                    <option value="2">1M</option>

                  </select>
                </td>
                <td data-label="Catagory">Tech Talent building solution</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Confident</option>
                    <option value="2">Expereince</option>

 
                  </select>
                </td>
              </tr>

              <tr>
              <td data-label="Category">Product Time Expereince</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">High</option>
                    <option value="2">Medium</option>
                    <option value="3">Low</option>
                  </select>
                </td>
                <td data-label="Catagory">Team Record</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Sucess</option>
                    <option value="2">No</option>
                    <option value="3">Failure</option>
                  </select>
                </td>
              </tr>
              <tr>
              <td data-label="Category">Research Expereince</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">High</option>
                    <option value="2">Medium</option>
                    <option value="3">Low</option>
                  </select>
                </td>
                <td data-label="Catagory">Full Control OVer Texh Stack</td>
                <td data-label="Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Sucess</option>
                    <option value="2">No</option>
                    <option value="3">Failure</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Category">Total</td>
                <td data-label="Score">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
                <td data-label="Catagory"></td>
                <td data-label="Score">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/problemValidation')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/cruxCompetative')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default SolutionScoreCard;